import { useUiTranslator } from "../hooks/useUiTranslator";

import { ReactNode, useState } from "react";

import ClearAllIcon from "@mui/icons-material/ClearAll";
import { Button, Typography } from "@mui/material";

import { ModalDialogConfirm } from "./common/ModalDialogConfirm/ModalDialogConfirm";

export const BtnCleanProjectList = (): ReactNode => {
  const t = useUiTranslator();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sendingHasError, setSendingHasError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const handleClean = async (): Promise<void> => {
    let response;
    setSendingHasError(false);

    setIsLoading(true);
    try {
      response = await fetch(`/api/QuoteApi/CleanProjectList`, {
        method: "GET",
      });

      if (response.status == 200) {
        setTimeout(() => (window.location.pathname = "/"), 500);
      } else {
        const errorMessage = await response.text();
        setErrorMessage(errorMessage);
        setSendingHasError(true);
        console.error("Error in BtnCleanProjectList", response);
      }
    } catch (error) {
      setSendingHasError(true);
      setErrorMessage("Error in BtnCleanProjectList");
      console.error("Error in BtnCleanProjectList", error);
    }
    setIsLoading(false);
  };

  const handleOpenConfirmModal = (): void => {
    setIsConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = (): void => {
    setIsConfirmModalOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpenConfirmModal}
        startIcon={<ClearAllIcon />}
      >
        <Typography>
          {t("CustomApp:btn.cleanProjectList", "Clear List")}
        </Typography>
      </Button>
      <ModalDialogConfirm
        isOpen={isConfirmModalOpen}
        onClose={handleCloseConfirmModal}
        startIcon={<ClearAllIcon />}
        confirmLabel={t("CustomApp:btn.cleanProjectList", "Clear List")}
        onConfirm={handleClean}
        onCancel={handleCloseConfirmModal}
        message={t(
          "CustomApp:message.cleanProjectList",
          "Doing this will completely empty your project list.",
        )}
        title={t("CustomApp:title.cleanProjectList", "Clear List")}
        isLoading={isLoading}
        hasError={sendingHasError}
        msgError={errorMessage}
      />
    </>
  );
};
